import { useMediaQuery } from '@uidotdev/usehooks'
import classNames from 'classnames'
import React, { useEffect, useState } from 'react'
import TinySlider from 'tiny-slider-react'
import 'tiny-slider/dist/tiny-slider.css'
import { CAROUSEL_CONFIG, VIRTUAL_TOUR_TABS } from '../../constant'
import CarouselController from '../carousel-controller'
import Hotspot from '../hotspot/hotspot'
import InteriorController from '../interior-controller'
import TourController from '../tour-controller'
import './styles.scss'
import { useIsRatioLandscape } from './helpers'

function Interior({ className = '', slides = [], onTabChange }) {
  let isRatioLandscape = useIsRatioLandscape()

  const isPhoneScreen = useMediaQuery('screen and (max-width: 1080px)')
  const [carousel, setCarousel] = useState(null)
  const [currentTab, setCurrentTab] = useState(1)
  const onGoTo = (dir) => carousel.slider.goTo(dir)
  return (
    <div
      className={classNames({
        [className]: true,
        c: true,
        'virtual-tour-image--landscape': isRatioLandscape,
      })}
    >
      <TinySlider
        className={'virtual-tour-image__slider'}
        settings={{ ...CAROUSEL_CONFIG, navContainer: '.dots-container' }}
        ref={(ts) => {
          setCarousel(ts)
        }}
        onIndexChanged={(index) => setCurrentTab(index?.displayIndex)}
      >
        {slides.map(({ image, hotspots }, index) => (
          <div
            key={index}
            className="vt-slide-container"
          >
            <div
              className={classNames({
                'virtual-tour-image': true,
                'use-width': isRatioLandscape,
                'use-height': !isRatioLandscape,
              })}
            >
              <img src={isPhoneScreen ? image.sm : image.lg} />
              {hotspots.map((hotspot, index) => (
                <Hotspot
                  key={index}
                  hotspot={hotspot}
                />
              ))}
            </div>
          </div>
        ))}
      </TinySlider>

      {isPhoneScreen ? (
        <InteriorController
          activeTab={VIRTUAL_TOUR_TABS.INTERIOR}
          setTab={onTabChange}
          index={currentTab}
          count={slides.length}
          onClick={(dir) => onGoTo(dir)}
        />
      ) : (
        <>
          <TourController
            activeTab={VIRTUAL_TOUR_TABS.INTERIOR}
            setTab={onTabChange}
          />
          <CarouselController
            withNavigation
            index={currentTab}
            count={slides.length}
            onClick={(dir) => onGoTo(dir)}
          />
        </>
      )}
    </div>
  )
}

export default Interior
